import SuccessExtend from "pages/CompensationExtend/components/SuccessExtend/SuccessExtend";

export default SuccessExtend